<template>
	<div class="Datenschutz">
		<div class="container">
			<h1>{{ $t('navigationDatenschutz.title') }}</h1>
			<div class="row align-items-center">
				<div class="py-5 col-9">
					<h4 class="UnterUeberschrift mb-4">
						{{ $t('navigationDatenschutz.datenschutz1.title') }}
					</h4>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz1.text.absatz1') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz1.text.subtitle1') }}
					</h5>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz1.text.absatz2') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz1.text.subtitle2') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz1.text.absatz3') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz1.text.absatz4') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz1.text.subtitle3') }}
					</h5>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz1.text.absatz5') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz1.text.subtitle4') }}
					</h5>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz1.text.absatz6') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz1.text.subtitle5') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz1.text.absatz7') }}
					</div>
				</div>

				<div class="py-5 col-9">
					<h4 class="UnterUeberschrift mb-4">
						{{ $t('navigationDatenschutz.datenschutz2.title') }}
					</h4>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz2.text.subtitle1') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz2.text.absatz1') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz2.text.absatz2') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz2.text.absatz3') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz2.text.absatz4') }}
					</div>
					<div>
						{{ $t('navigationDatenschutz.datenschutz2.text.absatz5') }}
					</div>
					<div>
						{{ $t('navigationDatenschutz.datenschutz2.text.absatz6') }}
					</div>
					<div class="mb-1">
						{{ $t('navigationDatenschutz.datenschutz2.text.absatz7') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz2.text.absatz8') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz2.text.subtitle2') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz2.text.absatz9') }}
					</div>
				</div>

				<div class="py-5 col-9">
					<h4 class="UnterUeberschrift mb-4">
						{{ $t('navigationDatenschutz.datenschutz3.title') }}
					</h4>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle1') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz1') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz2') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz3') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle2') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz4') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz5') }}
					</div>
					<div>
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz6') }}
					</div>
					<div>
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz7') }}
					</div>
					<div>
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz8') }}
						<a href="tel:09251 8998639">09251 8998639</a>
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz9') }}
						<a href="mailto:info@sos-p.com">info@sos-p.com</a>
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz10') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle3') }}
					</h5>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz11') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle4') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz12') }}
					</div>
					<div>
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz12a') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz13') }}
					</div>
					<div>
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz14') }}
					</div>
					<div>
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz15') }}
					</div>
					<div>
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz16') }}
						<a href="tel:09251 8998639">09251 8998639</a>
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz17') }}
						<a href="mailto:info@sos-p.com">info@sos-p.com</a>
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle5') }}
					</h5>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz18') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle6') }}
					</h5>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz19') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle7') }}
					</h5>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz20') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle8') }}
					</h5>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz21') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle9') }}
					</h5>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz22') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle10') }}
					</h5>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle11') }}
					</h5>
					<div class="mb-4">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz23') }}
					</div>
					<div class="mb-4">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz24') }}
					</div>
					<div class="mb-4">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz25') }}
					</div>
					<div class="mb-4">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz26') }}
					</div>
					<div class="mb-4">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz27') }}
					</div>
					<div class="mb-4">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz28') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz29') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle12') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz30') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz31') }}
						<a href="mailto:info@sos-p.com">info@sos-p.com</a>
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz3.text.subtitle13') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz3.text.absatz32') }}
					</div>
					<ul>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz3.text.absatz33') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz3.text.absatz34') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz3.text.absatz35') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz3.text.absatz36') }}
						</li>
					</ul>
				</div>

				<div class="py-5 col-9">
					<h4 class="UnterUeberschrift mb-4">
						{{ $t('navigationDatenschutz.datenschutz4.title') }}
					</h4>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz1') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz2') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz3') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz4') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz5') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz4.text.subtitle1') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz6') }}
						<a href="https://sos-p.com">www.sos-p.com</a>
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz7') }}
					</div>
					<ul class="mb-5">
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz8') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz9') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz10') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz11') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz12') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz13') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz14') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz15') }}
						</li>
					</ul>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz16') }}
					</div>
					<ul>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz17') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz18') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz19') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz20') }}
						</li>
					</ul>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz21') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz22') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz4.text.subtitle2') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz23') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz24') }}
					</div>
					<ul class="mb-5">
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz25') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz26') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz27') }}
						</li>
						<li class="mb-2">
							{{ $t('navigationDatenschutz.datenschutz4.text.absatz28') }}
						</li>
					</ul>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz4.text.subtitle3') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz29') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz30') }}
					</div>
					<div class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz4.text.absatz31') }}
					</div>
				</div>

				<div class="py-5 col-9">
					<h4 class="UnterUeberschrift mb-4">
						{{ $t('navigationDatenschutz.datenschutz5.title') }}
					</h4>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz5.text.absatz1') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz5.text.absatz2') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz5.text.absatz3') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz5.text.subtitle1') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz5.text.absatz4') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz5.text.absatz5') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz5.text.absatz6') }}
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz5.text.subtitle2') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz5.text.absatz7') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz5.text.absatz8') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz5.text.absatz9') }}
					</div>
					<div class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz5.text.absatz10') }}
						<a
							target="_blank"
							href="https://privacy.google.com/businesses/controllerterms/mccs/"
							>https://privacy.google.com/businesses/controllerterms/mccs/</a
						>
					</div>
				</div>

				<div class="py-5 col-9">
					<h4 class="UnterUeberschrift mb-4">
						{{ $t('navigationDatenschutz.datenschutz6.title') }}
					</h4>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz6.text.subtitle1') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz1') }}
					</div>
					<div class="mb-1">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz2') }}
						<a target="_blank" href="https://policies.google.com/privacy"
							>https://policies.google.com/privacy</a
						>
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz3') }}
						<a
							target="_blank"
							href="https://adssettings.google.com/authenticated"
							>https://adssettings.google.com/authenticated</a
						>
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz4') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz5') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz6') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz7') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz8') }}
						<a target="_blank" href="https://policies.google.com/privacy?hl=de"
							>https://policies.google.com/privacy?hl=de</a
						>
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz6.text.subtitle2') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz9') }}
					</div>
					<div class="mb-1">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz10') }}
						<a target="_blank" href="https://developers.google.com/fonts/faq"
							>https://developers.google.com/fonts/faq</a
						>
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz11') }}
						<a target="_blank" href="https://policies.google.com/privacy?hl=de"
							>https://policies.google.com/privacy?hl=de</a
						>.
					</div>
					<div class="mb-5">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz12') }}
						<a
							target="_blank"
							href="https://adssettings.google.com/authenticated"
							>https://adssettings.google.com/authenticated</a
						>
					</div>
					<h5 class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz6.text.subtitle3') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz13') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz14') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz15') }}
						<a target="_blank" href="https://policies.google.com/privacy"
							>https://policies.google.com/privacy</a
						>
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz16') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz17') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz18') }}
						<a target="_blank" href="https://policies.google.com/privacy"
							>https://policies.google.com/privacy</a
						>
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz19') }}
						<a
							target="_blank"
							href="https://www.privacyshield.gov/EU-US-Framework"
							>https://www.privacyshield.gov/EU-US-Framework</a
						>.
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz20') }}
						<a
							target="_blank"
							href="https://adssettings.google.com/authenticated"
							>https://adssettings.google.com/authenticated</a
						>
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz21') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz22') }}
					</div>

					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz23') }}
					</div>
					<div class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz24') }}
					</div>
					<div class="mb-3">
						<a
							target="_blank"
							href="https://privacy.google.com/businesses/gdprcontrollerterms/"
							>https://privacy.google.com/businesses/gdprcontrollerterms/</a
						>
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz25') }}
						<a
							target="_blank"
							href="https://privacy.google.com/businesses/gdprcontrollerterms/sccs/"
							>https://privacy.google.com/businesses/gdprcontrollerterms/sccs/</a
						>
					</div>
					<div class="mb-2">
						{{ $t('navigationDatenschutz.datenschutz6.text.absatz26') }}
						<a target="_blank" href="https://policies.google.com/privacy"
							>https://policies.google.com/privacy</a
						>
					</div>
				</div>

				<div class="py-5 col-9">
					<h4 class="UnterUeberschrift mb-4">
						{{ $t('navigationDatenschutz.datenschutz7.title') }}
					</h4>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz7.text.absatz1') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDatenschutz.datenschutz7.text.absatz2') }}
					</div>
					<div>
						{{ $t('navigationDatenschutz.datenschutz7.text.absatz3') }}
						<a href="https://sos-p.com/#/datenschutz"
							>https://sos-p.com/#/datenschutz</a
						>
						{{ $t('navigationDatenschutz.datenschutz7.text.absatz4') }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Datenschutz',
	i18n: {
		messages: {
			de: require('@/i18n/de/de_datenschutz.json'),
			en: require('@/i18n/en/eng_datenschutz.json')
		}
	}
}
</script>

<style scoped lang="stylus">

a {
	color: red;
}
</style>
